import { createSelector } from 'reselect';

import { State } from './reducer';
import { Entities } from './types';

export const selectData = (state: any) => state.coinAnalysis;

export const getEntities = createSelector(
  [selectData],
  (state: State) => state.entities,
);

export const getByCoinId = (coinId: string) =>
  createSelector([getEntities], (entities: Entities) => {
    if (entities[coinId]) {
      return entities[coinId];
    }

    return null;
  });
